module.exports = __webpack_public_path__ + "img/17_81.fe9590b1.png";